"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeField = DateRangeField;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const DateFieldBase_1 = require("./DateFieldBase");
function DateRangeField(props) {
    return (0, jsx_runtime_1.jsx)(DateFieldBase_1.DateFieldBase, { ...props, mode: "range" });
}
